export default {
  not_started:
    "Configurez votre compte de paiement — votre part de revenus est suspendue jusqu'à ce qu'il soit vérifié.",
  bank_account_missing:
    "Ajoutez un compte bancaire pour les paiements — votre part de revenus est suspendue jusqu'à ce que vous le fassiez.",
  incomplete:
    "Votre compte de paiement n'est pas encore entièrement vérifié — votre part de revenus est suspendue jusqu'à ce qu'il le soit.",
  add_bank_account: 'Ajouter un compte bancaire',
  cta: 'Terminer la configuration',
};
